import { BUSINESS_INDUSTRIES } from '@/constants';
import { DOCUMENT_DICT } from '@/constants/documents';
import { ONBOARDING_BUSINESS_DICT } from '@/constants/onboarding';
import { i18n } from '@/i18n';
import { DocumentWrapper, OnboardingDocument, UnionDocument } from '@/types/interfaces/Document.interface';

export function getOptionsList<T extends keyof typeof ONBOARDING_BUSINESS_DICT>(
  valuesName: T,
  localizeLabel: boolean = false,
): { label: string; value: string }[] {
  return ONBOARDING_BUSINESS_DICT[valuesName].map((value) => {
    const label = `entity.${valuesName}.${value}`;
    return {
      label: localizeLabel ? i18n.global.t(label) : label,
      value,
    };
  });
}

export function getBusinessIndustryOptionsList(selectedOption?: string) {
  if (!selectedOption) return getOptionsList('BusinessIndustry');
  if (BUSINESS_INDUSTRIES.includes(selectedOption)) return getOptionsList('BusinessIndustry');
  return [...getOptionsList('BusinessIndustry'),
    {
      value: selectedOption,
      label: i18n.global.t(`entity.BusinessIndustry.${selectedOption}`),
    },
  ].sort((a, b) => a.value.localeCompare(b.value));
}

export function getCustomOptionsList<T extends keyof typeof ONBOARDING_BUSINESS_DICT>(
  dict: string[],
  valuesName: T,
  localizeLabel: boolean = false,
): { label: string; value: string }[] {
  return dict.map((value) => {
    const label = `entity.${valuesName}.${value}`;
    return {
      label: localizeLabel ? i18n.global.t(label) : label,
      value,
    };
  });
}

export function getDocumentsOptionList<T extends keyof typeof DOCUMENT_DICT>(
  valuesName: T,
  uploadedDocumentList: Record<UnionDocument, OnboardingDocument>,
): DocumentWrapper<typeof DOCUMENT_DICT[T][number]>[] {
  return DOCUMENT_DICT[valuesName].map((type) => ({
    label: `entity.${valuesName}.${type}`,
    type,
    isUploaded: !!uploadedDocumentList[type],
  }));
}
